import styled from 'styled-components'
import { ASSETS } from '../../../../constants/assets'

export const BlogPostContainer = styled.div<{ $isSecondaryBlogPost: boolean }>`
  width: 100%;
  background: ${({ theme, $isSecondaryBlogPost }) =>
    $isSecondaryBlogPost ? theme.webMktNewPalette.deepBlue[10] : theme.webMktNewPalette.white};
  position: relative;

  .BlogPost-Bg-Container {
    position: absolute;
    top: 0;
    height: 280px;
    width: 100%;
    max-width: 100%;
    background-size: 100%;
    background-repeat: no-repeat;
    background-image: ${({ $isSecondaryBlogPost }) =>
      $isSecondaryBlogPost
        ? `url(
            ${ASSETS.HERO_BACKGROUND}
          )`
        : `url(
            ${ASSETS.BLOG_HEADER_DECORATION}
          )`};

    ${({ theme }) => theme.breakpoints.down('sm')} {
      background-image: url('/steam-img/Grid-Partners.svg');
      background-repeat: repeat;
      background-size: unset;
      height: 100px;
    }
  }

  h1 {
    position: relative;
    z-index: 1;
  }

  .BlogPost__Body a {
    color: #08c;
  }

  .BlogPost__Breadcrumbs {
    position: relative;
    z-index: 1;
    display: flex;
    padding-top: 30px;
    margin-bottom: 80px;
  }

  ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .BlogPost__Breadcrumbs li {
    position: relative;
    z-index: 1;
    color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    font-weight: 800;
    font-size: 16px;
    color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    line-height: 24px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .BlogPost__Byline {
    z-index: 1;
    position: relative;
    display: inline-flex;
    align-items: center;
    margin-bottom: 32px;
  }

  .BlogPost__Byline > * {
    margin-right: 8px;
  }

  .BlogPost__Byline-Date {
    font-weight: bold;
  }

  .BlogPost__Post-Container {
    display: flex;
    justify-content: center;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .BlogPost__Image-Container {
    height: 600px;
    margin-bottom: 48px;

    ${({ theme }) => theme.breakpoints.down('xs')} {
      height: 100%;
    }
  }

  .BlogPost__Image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .BlogPost__SocialMedia-Container {
    height: 100%;
    display: flex;
    margin-bottom: 34px;
    flex-direction: column;
    position: sticky;
    top: 120px;
  }

  .BlogPost__SocialMedia-Item {
    display: flex;
    flex-direction: column;
    width: 24px;
    height: 24px;
    margin-left: -126px;
    margin-right: 0;
    margin-bottom: 32px;
    top: 120px;
  }

  .BlogPost__SocialMedia-Item svg:hover path {
    fill: ${({ theme }) => theme.webMktPalette.icon.blueLight};
  }

  .BlogPost__Body-Container {
    max-width: 588px;
    width: 100%;
  }

  .BlogPost__Body > img {
    margin: 32px 0;
  }

  .BlogPost__Body div > img {
    max-height: 632px;
  }

  .BlogPost__Body > p {
    word-wrap: break-word;
    color: rgb(39, 49, 57);
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 24px;
  }

  .BlogPost__Body div {
    margin-top: 16px;
    margin-bottom: 32px;
    padding: 0;
  }

  .BlogPost__Body blockquote {
    background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
    position: relative;
    margin: 80px 0 60px 0;
    border-left: 0;
    padding: 48px;

    ${({ theme }) => theme.breakpoints.down('md')} {
      width: 632px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 534px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      padding: 48px 24px;
      width: 327px;
    }
  }

  .BlogPost__Body blockquote::before {
    content: '';
    position: absolute;
    top: -30px;
    left: 48px;
    width: 74px;
    height: 56px;
    background-image: url(${ASSETS.BLOCKQUOTE});
  }

  .BlogPost__Body blockquote > p {
    color: #273139;
  }

  .BlogPost__Body blockquote p:last-child,
  .BlogPost__Body blockquote p:last-child span {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-top: 32px;
  }

  .BlogPost__Body blockquote p:first-child {
    font-size: 24px;
    line-height: 36px;
    font-weight: 400;
    letter-spacing: -0.5px;

    ${({ theme }) => theme.breakpoints.down('md')} {
      font-size: 20px;
      line-height: 32px;
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      font-size: 20px;
      line-height: 32px;
      letter-spacing: 0px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      font-size: 20px;
      line-height: 32px;
      letter-spacing: 0px;
    }
  }

  .BlogPost__Body ul {
    list-style: none;
    margin-left: 26px;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .BlogPost__Body ul > li > p {
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
  }

  .BlogPost__Body ul > li {
    position: relative;
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    margin-bottom: 32px;
  }

  .BlogPost__Body ul li:before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
    position: absolute;
    top: 7px;
    left: -26px;
  }

  .BlogPost__Body > ol {
    list-style: decimal;
    margin-left: 20px;
    margin-top: 16px;
    margin-bottom: 32px;
  }

  .BlogPost__Body > ol > li > * {
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    margin-bottom: 16px;
  }

  .BlogPost__Body .inline-entry {
    display: inline-block;
    margin: 0;
  }
  .BlogPost__Body .inline-entry div {
    margin: 0;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 48px 0;
  }

  .BlogPost__Body h2 > a + span.LineBreak,
  .BlogPost__Body h3 > a + span.LineBreak,
  .BlogPost__Body h4 > a + span.LineBreak,
  .BlogPost__Body h5 > a + span.LineBreak,
  .BlogPost__Body h6 > a + span.LineBreak {
    display: inline;
  }

  .BlogPost__Tags-Container {
    padding-top: 25px;
    padding-bottom: 25px;
    border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
    border-bottom: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
    margin-top: 32px;
  }

  .BlogPost__Tags-Heading {
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    font-weight: 600;
    display: inline-flex;
  }

  .BlogPost__Tags > * {
    margin-right: 9px;
  }

  .BlogPost__Tag {
    display: inline-flex;
    padding-left: 16px;
    padding-right: 16px;
    border: 1px solid #e3e3e3;
    border-radius: 50px;
    margin-top: 9px;
    color: #273139;
  }

  .BlogPost__Author {
    display: flex;
    padding-top: 48px;
    padding-bottom: 96px;
  }
`

export const TagsContainer = styled.div`
  padding-top: 25px;
  padding-bottom: 25px;
  border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
  border-bottom: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
  margin-top: 32px;

  .Tags__Heading {
    font-weight: 400;
    font-size: 16px;
    color: #273139;
    line-height: 24px;
    font-weight: 600;
    display: inline-flex;
  }

  .Tags__Group > * {
    margin-right: 9px;
  }

  .Tag {
    margin-right: 9px;
    display: inline-flex;
    padding-left: 16px;
    padding-right: 16px;
    border: 1px solid #e3e3e3;
    border-radius: 50px;
    margin-top: 9px;
    color: #273139;
  }
`
